module.exports = __webpack_public_path__ + "static/img/gift.555a4dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/gift.png
// module id = okVL
// module chunks = 0